import React from 'react';
import {View} from 'react-native';

const LinearGradient = ({colors = [], locations, style, children, ...rest}) => {
  const colorStops = colors.map((c, i) => {
    const pos = locations && locations[i] != null ? `${locations[i] * 100}%` : undefined;
    return pos ? `${c} ${pos}` : c;
  }).join(', ');

  return (
    <View
      {...rest}
      style={[
        style,
        {backgroundImage: `linear-gradient(to bottom, ${colorStops})`},
      ]}>
      {children}
    </View>
  );
};

export default LinearGradient;
